import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthResponse, Login } from '../../models/auth';
import { environment } from '../../../../environments/environment';
import { Store } from '@ngrx/store';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  constructor(
    private http: HttpClient,
    private store: Store
  ) { }

  public getToken() {
    // return this.store.select(selectToken);
  }

  public login(username: string, password: string): Observable<AuthResponse> {
    const Login: Login = {
      password: password,
      email: username,
    };
    return this.http.post<AuthResponse>(  environment.apiUrl  + '/user/login' , { username: Login.email, password: Login.password });
  }

}
